import { useEffect, useRef } from "react";
import { getCaptableRun } from "../api/dataPipeline";
import {
  isCaptableRunInFlight,
  useAuthStore,
  useCaptableStore,
} from "../store";

const POLL_INTERVAL_MS = 5000;

export default function CaptableManager() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const runsMap = useCaptableStore((s) => s.runs);
  const applyStatus = useCaptableStore((s) => s.applyStatus);

  const runsRef = useRef(runsMap);
  runsRef.current = runsMap;

  useEffect(() => {
    if (!isAuthenticated) return undefined;
    const interval = setInterval(async () => {
      const inFlight = Object.values(runsRef.current).filter(
        isCaptableRunInFlight,
      );
      if (inFlight.length === 0) return;
      await Promise.all(
        inFlight.map(async (entry) => {
          try {
            const data = await getCaptableRun(entry.runId);
            applyStatus(data);
          } catch {
            // swallow; next poll may recover
          }
        }),
      );
    }, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [isAuthenticated, applyStatus]);

  return null;
}
